import React from 'react';

interface FsCheckboxLargeDefaultIconProps {
  color?: string;
}

const FsCheckboxLargeDefaultIcon: React.FC<FsCheckboxLargeDefaultIconProps> = ({
  color = 'white',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="25" height="25" rx="3.5" stroke={color} />
    </svg>
  );
};

export default FsCheckboxLargeDefaultIcon;
